module.exports = __webpack_public_path__ + "img/QR.5258f7d2.png";